import AddIcon from "@mui/icons-material/Add"
import { Box, Button, IconButton } from "@mui/material"
import React from "react"
import { useSelector } from "react-redux"
import { allFeaturesRoles } from "../../utils/constants"

function CustomButton(props) {
  const { text, onClick, type, size = "medium" } = props
  let sx = {
    textTransform: "none",
    width: "fit-content",
    ...props.sx,
  }

  return (
    <Button
      variant="contained"
      color="primary"
      // fullWidth
      onClick={onClick}
      {...props}
      sx={sx}
      size={size}
    >
      {text}
    </Button>
  )
}

const PlusButton = ({ onClickPlus }) => {
  return (
    <IconButton
      // edge="end"
      onClick={onClickPlus}
      sx={{
        backgroundColor: "#3083EF",
        width: 40,
        height: 40,
        borderRadius: 1,
        "&:hover": {
          backgroundColor: "#3083EF",
        },
      }}
    >
      <AddIcon sx={{ width: "40px", height: "40px", color: "#fff" }} />
    </IconButton>
  )
}

function GetUserInfo() {
  const activeTab = useSelector((state) => state.app.activeTab)
  const role = useSelector((state) => state.app.userData.role)
  const canShowAll = allFeaturesRoles.includes(role?.toUpperCase())

  return { activeTab, role, canShowAll }
}

function SectionHeader({ title }) {
  return (
    <Box
      sx={{
        height: "50px",
        minHeight: "50px",
        display: "flex",
        alignItems: "center",

        justifyContent: "center",
        backgroundColor: "#dfdfdd",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
      }}
    >
      <h3 style={{ margin: 0 }}>{title}</h3>
    </Box>
  )
}

export { CustomButton, PlusButton, GetUserInfo, SectionHeader }
